import resolveResponsiveValue from './ResponsiveValueResolver';
export default function resolveColor(theme, screenWidth, color) {
    var activeColor = resolveResponsiveValue(theme, screenWidth, color);
    if (!activeColor) {
        return undefined;
    }
    if (typeof activeColor === 'object') {
        return activeColor.custom;
    }
    return theme.colorScheme[activeColor];
}
//# sourceMappingURL=ColorResolver.js.map